import { createSlice } from "@reduxjs/toolkit";

export const panCardSlice = createSlice({
  name: "panDetails",

  initialState: {
    // panUserdata: {},
    panUserdata: {residentialStatus: "Resident Individual"},
    userPanNumber: "",
    userTempPanNumber: "",
    userPanDOB: "",
    isPanVal:""
  },
  reducers: {
    panUserdata: (state, action) => {
      state.panUserdata = action.payload;
    },
    // aadhaarUserdata: (state, action) => {
    //   state.aadhaarUserdata = action.payload;
    // },
    userPanNumber: (state, action) => {
      state.userPanNumber = action.payload;
    },
    userTempPanNumber: (state, action) => {
      state.userTempPanNumber = action.payload;
    },
    userPanDOB: (state, action) => {
      state.userPanDOB = action.payload;
    },
    isPanVal: (state, action) => {
      state.isPanVal = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { panUserdata, userPanNumber , userPanDOB , userTempPanNumber,isPanVal} = panCardSlice.actions;

export default panCardSlice.reducer;
